import { openAlertModal } from 'admin/actions/alert-modal';
import { showPokeregi, updatePokeregi } from 'admin/actions/devices';
import { hideLoadingSpinner, showLoadingSpinner } from 'admin/actions/loading-spinner';
import { getOrganizations } from 'admin/actions/organization';
import { getPrivateMoneys } from 'admin/actions/private-moneys';
import { getShopAccounts, getShops } from 'admin/actions/shops';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import Input from 'admin/components/shared/Input';
import Select from 'admin/components/shared/Select';
import PokeregiBLECommunicatorMixin from 'admin/mixins/PokeregiBLECommunicatorMixin';
import { formatUUID, toQueryParams } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import mixin from 'react-mixin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './styles.scss';

const PokeregiInitialState = {
  serial_number: null,
  topup_mode: 'disable',
  topup_passcode: '',
  topup_passcode_visible: false,
  transfer_limit: 30000,
  organization_code: '',
  shop_id: '',
  account_id: '',
  name: '',
  client_key: '',
  hardware_id: '',
  pcb_ver: '',
  fw_ver: '',
};

const collectDiff = (org, newv, props) => {
  const rt = {};
  props.forEach((p) => {
    if (org[p] !== newv[p]) rt[p] = newv[p];
  });
  return rt;
};

class UpdatePokeregi extends Component {
  constructor(props) {
    super(props);
    this.defaultMoney = this.props.user.defaultMoney();
    this.state = {
      ble: null,
      pokeregi: PokeregiInitialState,
      privateMoneys: { rows: [], count: 0, pagination: {} },
      selectedPrivateMoney: null,
    };
  }

  isOrganizationSelectable() {
    return ['SERVICE-MANAGER', 'SERVICE-STAFF'].includes(this.props.user.role);
  }

  componentWillMount() {
    const id = this.props.match.params.id;
    this.props.showPokeregi(id);
  }

  componentWillUpdate(newProps, newState) {
    if (this.props.pokeregi !== newProps.pokeregi) {
      this.setState({ pokeregi: Object.assign({}, this.state.pokeregi, newProps.pokeregi) }, () => {
        if (this.isOrganizationSelectable()) {
          getPrivateMoneys('per_page=2000').then((moneys) => {
            const money = moneys.rows.find((m) => m.name === this.props.pokeregi.money_name);
            this.setState({ privateMoneys: moneys, selectedPrivateMoney: money.id });
            this.props.getOrganizations(
              toQueryParams({
                private_money_id: money.id,
                per_page: 10000,
              })
            );
          });
          this.props.getShops(
            toQueryParams({
              per_page: 5000,
              organization_code: this.props.pokeregi.organization_code,
            })
          );
        } else {
          this.props.getShops(
            toQueryParams({
              per_page: 5000,
              organization_code: this.props.pokeregi.organization_code,
            })
          );
        }
        this.props.getShopAccounts(this.props.pokeregi.shop_id);
        if (this.state.ble && newProps.pokeregi.encoded) {
          this.bleWriteSettings(this.state.ble, newProps.pokeregi.encoded)
            .then(() => {
              this.props.hideLoadingSpinner();
              this.props.openAlertModal({
                body: <p>更新に成功しました</p>,
                confirmText: '詳細を表示',
                onConfirm: () => {
                  this.props.history.push(
                    `/settings/devices/pokeregi/${newProps.pokeregi.serial_number}`
                  );
                },
                onCancel: () => {
                  this.setState({ ble: null });
                },
              });
            })
            .catch((e) => {
              this.props.hideLoadingSpinner();
              this.props.openAlertModal({
                body: <p>ポケレジへの書き込みに失敗しました</p>,
                confirmText: '閉じる',
                useCancel: false,
              });
            });
        }
      });
    }
    if (newProps.api_error !== this.props.api_error) {
      this.props.hideLoadingSpinner();
      const getMessage = (e) => {
        const { type } = e;
        switch (type) {
          case 'invalid_parameters':
            return `入力内容をご確認ください (${e.errors.invalid.join(',')})`;
          case 'account_not_accessible':
            return 'アカウントにアクセスできません';
          default:
            return '処理に失敗しました';
        }
      };
      this.props.openAlertModal({
        body: <p>{getMessage(newProps.api_error)}</p>,
        confirmText: '閉じる',
        useCancel: false,
      });
    }
  }

  back() {
    this.props.history.goBack();
  }

  edit() {
    this.bleSearchDevice(this.state.pokeregi.hardware_id)
      .then((ble) => {
        this.setState({ ble });
        this.props.showLoadingSpinner();
        this.bleReadSettings(ble).then((jwt) => {
          const { header, payload } = jwt;
          if (payload.serial_number !== this.state.pokeregi.serial_number) {
            this.props.hideLoadingSpinner();
            this.props.openAlertModal({
              body: <p>このポケレジは、更新対象ではありません</p>,
              confirmText: '詳細を表示',
              cancelText: 'やめる',
              onConfirm: () => {
                this.props.history.push(`/settings/devices/pokeregi/${payload.serial_number}`);
              },
            });
            return;
          }
          const algorithm = header.alg.toLowerCase();
          this.assignStatePokeregi(
            {
              client_key: algorithm === 'hs256' ? payload.shared_key : payload.public_key,
              hardware_id: payload.hardware_id,
            },
            () => {
              const sendData = {};
              const diff = collectDiff(this.props.pokeregi, this.state.pokeregi, [
                'account_id',
                'name',
                'topup_mode',
                'topup_passcode',
                'transfer_limit',
              ]);
              if (diff.account_id || diff.name) {
                sendData.account_id = this.state.pokeregi.account_id;
                sendData.hardware_id = this.state.pokeregi.hardware_id;
                sendData.client_key = this.state.pokeregi.client_key;
                sendData.name = this.state.pokeregi.name;
              }
              if (diff.topup_mode) {
                sendData.topup_mode = this.state.pokeregi.topup_mode;
                sendData.topup_passcode = this.state.pokeregi.topup_passcode;
              }
              if (diff.topup_passcode) {
                sendData.topup_passcode = this.state.pokeregi.topup_passcode;
              }
              if (diff.transfer_limit) {
                sendData.transfer_limit = this.state.pokeregi.transfer_limit;
              }
              this.props.updatePokeregi(payload.serial_number, sendData);
            }
          );
        });
      })
      .catch((e) => {
        this.props.hideLoadingSpinner();
        if (e.message.match(/User cancelled/)) {
          return;
        }
        console.error(e.name);
        console.error(e.message);
        console.error(e.stack);
      });
  }

  assignStatePokeregi(up, then = () => {}) {
    this.setState({ pokeregi: Object.assign({}, this.state.pokeregi, up) }, then);
  }

  onSelectTopupMode(e) {
    const topup_mode = e.target.value;
    this.assignStatePokeregi({ topup_mode }, () => {
      if (topup_mode !== 'enable') {
        this.assignStatePokeregi({
          topup_passcode: '',
        });
      }
    });
  }

  onChangeTransferLimit(e) {
    let value = parseInt(e.target.value);
    if (isNaN(value)) value = 0;
    this.assignStatePokeregi({ transfer_limit: value });
  }

  onSelectedPrivateMoney = (e) => {
    const private_money_id = e.target.value;
    this.props.getOrganizations(
      toQueryParams({
        private_money_id,
        per_page: 10000,
      })
    );
    this.setState({ selectedPrivateMoney: e.target.value });
  };

  onSelectOrganization(e) {
    const organization_code = e.target.value;
    if (!organization_code) return;
    this.props.getShops(
      toQueryParams({
        organization_code,
        per_page: 5000,
      })
    );
    this.assignStatePokeregi({
      organization_code,
      shop_id: '',
      account_id: '',
    });
  }

  onSelectShop(e) {
    const shop_id = e.target.value;
    if (!shop_id) return;
    this.assignStatePokeregi({
      shop_id,
      account_id: '',
    });
    this.props.getShopAccounts(shop_id);
  }

  onSelectShopAccount(e) {
    const account_id = e.target.value;
    if (!account_id) return;
    this.assignStatePokeregi({
      account_id,
    });
  }

  onChangeTerminalName(e) {
    const name = e.target.value;
    this.assignStatePokeregi({
      name,
    });
  }

  onChangeTopupPasscode(e) {
    const topup_passcode = e.target.value;
    if (topup_passcode.match(/^\d{0,16}$/)) {
      this.assignStatePokeregi({
        topup_passcode,
      });
    }
  }

  onChangeTopupPasscodeVisible(e) {
    this.assignStatePokeregi({
      topup_passcode_visible: e.target.checked,
    });
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'ポケレジ更新', href: '', active: true },
    ];
    const topupModeOptions = [
      { name: '不可', value: 'disable' },
      { name: '単体で可', value: 'enable' },
      { name: 'レジ接続時可', value: 'enable-if-wired' },
    ];
    return (
      <div>
        <div>
          <Breadcrumb items={crumb} />
          <div>
            <row styleName="row">
              <div styleName="cat-label">ポケレジ設定</div>
              <div styleName="cat-val">
                <row styleName="row">
                  <div styleName="label">製造番号</div>
                  <div styleName="val">{this.state.pokeregi.serial_number}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">ハードウェアID</div>
                  <div styleName="val">{formatUUID(this.state.pokeregi.hardware_id)}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">チャージの可/不可</div>
                  <div styleName="val">
                    <Select
                      id="topup-mode-select"
                      options={topupModeOptions}
                      value={this.state.pokeregi.topup_mode}
                      onChange={this.onSelectTopupMode.bind(this)}
                      required
                    />
                  </div>
                </row>
                {this.state.pokeregi.topup_mode === 'enable' ? (
                  <row styleName="row">
                    <div styleName="label">
                      チャージ時のパスコード
                      <br />
                      (半角数字4~16文字)
                    </div>
                    <div styleName="val">
                      <Input
                        id="topup-passcode-select"
                        type={this.state.pokeregi.topup_passcode_visible ? 'text' : 'password'}
                        value={this.state.pokeregi.topup_passcode}
                        onChange={this.onChangeTopupPasscode.bind(this)}
                        placeholder="変更しない場合は空"
                      />
                      <Input
                        type="checkbox"
                        style={{ float: 'left', marginTop: '5px' }}
                        checked={this.state.pokeregi.topup_passcode_visible}
                        onChange={this.onChangeTopupPasscodeVisible.bind(this)}
                      />
                      <span style={{ marginLeft: '5px', lineHeight: '28px' }}>
                        パスコードを表示
                      </span>
                    </div>
                  </row>
                ) : null}
                <row styleName="row">
                  <div styleName="label">最大入力可能金額</div>
                  <div styleName="val">
                    <Input
                      id="transfer-limit-input"
                      type="number"
                      onChange={this.onChangeTransferLimit.bind(this)}
                      value={this.state.pokeregi.transfer_limit}
                      required
                    />
                  </div>
                </row>
              </div>
            </row>
            <row styleName="row">
              <div styleName="cat-label">設置先設定</div>
              <div styleName="cat-val">
                <row styleName="row">
                  <div styleName="label">マネー</div>
                  <div styleName="val">
                    {this.isOrganizationSelectable() ? (
                      <Select
                        id="organization-select"
                        options={this.state.privateMoneys.rows.map(({ id, name }) => ({
                          name,
                          value: id,
                        }))}
                        onChange={this.onSelectedPrivateMoney}
                        defaultOptionLabel="選択してください"
                        value={this.state.selectedPrivateMoney}
                        required
                      />
                    ) : (
                      this.state.selectedPrivateMoney
                    )}
                  </div>
                </row>
                <row styleName="row">
                  <div styleName="label">組織</div>
                  <div styleName="val">
                    {this.isOrganizationSelectable() ? (
                      <Select
                        id="organization-select"
                        options={this.props.organizations.rows.map(({ code, name }) => ({
                          name,
                          value: code,
                        }))}
                        onChange={this.onSelectOrganization.bind(this)}
                        defaultOptionLabel="選択してください"
                        value={this.state.pokeregi.organization_code}
                        required
                      />
                    ) : (
                      this.state.pokeregi.organization_name
                    )}
                  </div>
                </row>
                <row styleName="row">
                  <div styleName="label">店舗</div>
                  <div styleName="val">
                    <Select
                      id="shop-select"
                      options={this.props.shops.rows.map(({ id, name }) => ({ name, value: id }))}
                      onChange={this.onSelectShop.bind(this)}
                      defaultOptionLabel="選択してください"
                      value={this.state.pokeregi.shop_id}
                      required
                    />
                  </div>
                </row>
                <row styleName="row">
                  <div styleName="label">アカウント</div>
                  <div styleName="val">
                    <Select
                      id="account-select"
                      options={this.props.shop_accounts.map(
                        ({ id, name, balance, money_name }) => ({
                          name: `(${id.slice(
                            0,
                            8
                          )}) マネー:"${money_name}" 口座名:"${name}" 残高:"${balance}"`,
                          value: id,
                        })
                      )}
                      onChange={this.onSelectShopAccount.bind(this)}
                      defaultOptionLabel="選択してください"
                      value={this.state.pokeregi.account_id}
                      required
                    />
                  </div>
                </row>
                <row styleName="row">
                  <div styleName="label">ポケレジの名前</div>
                  <div styleName="val">
                    <Input
                      id="terminal-name-input"
                      type="text"
                      onChange={this.onChangeTerminalName.bind(this)}
                      value={this.state.pokeregi.name}
                      style={{ width: '100%' }}
                      required
                    />
                  </div>
                </row>
              </div>
            </row>
          </div>
          <div styleName="button-group">
            <Button onClick={this.edit.bind(this)}>更新</Button>
            <Button onClick={this.back.bind(this)} color="gray">
              キャンセル
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

UpdatePokeregi.defaultProps = {
  user: {},
  pokeregi: {},
  organizations: { rows: [], count: 0, pagination: {} },
  shops: { rows: [], count: 0, pagination: {} },
  shop_accounts: [],
  api_error: null,
};

const mapStateToProps = (state) => ({
  user: state.user,
  pokeregi: state.device.pokeregi,
  organizations: state.organization.organizations,
  shops: state.shop.shops,
  shop_accounts: state.shop.shop_accounts,
  api_error: state.apiError.error,
});

UpdatePokeregi.propTypes = {
  user: PropTypes.object,
  pokeregi: PropTypes.shape({
    terminal_id: PropTypes.string,
    hardware_id: PropTypes.string,
    is_invalidated: PropTypes.boolean,
    account_id: PropTypes.string,
    name: PropTypes.string,
    shop_name: PropTypes.string,
    shop_id: PropTypes.string,
    organization_name: PropTypes.string,
    organization_code: PropTypes.string,
    account_name: PropTypes.string,
    money_name: PropTypes.string,
    serial_number: PropTypes.number,
    pcb_ver: PropTypes.string,
    fw_ver: PropTypes.string,
    topup_mode: PropTypes.string,
    topup_passcode: PropTypes.string,
    transfer_limit: PropTypes.number,
    encoded: PropTypes.string,
  }),
  organizations: PropTypes.object,
  shops: PropTypes.object,
  shop_accounts: PropTypes.array,
  api_error: PropTypes.object,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showPokeregi,
      updatePokeregi,
      openAlertModal,
      getOrganizations,
      getShops,
      getShopAccounts,
      showLoadingSpinner,
      hideLoadingSpinner,
    },
    dispatch
  );

mixin.onClass(UpdatePokeregi, PokeregiBLECommunicatorMixin);
export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(UpdatePokeregi, styles));
